import { getTravelMonths, formatTravelMonth } from 'UtilityComponents/miceUtils';
import { ASSET_PATH } from 'assetsPath';
import {
	validEmail,
	validPhone,
	formatName,
	isDeviceMobile
} from 'UtilityComponents/Util';
import { PATHS, MICE_CONSTANTS, APPLICATION_CONSTANTS } from 'AppConstants';
import { defaultCity } from './filterConfig';

const MICE_IMG_PATH = `${ASSET_PATH.IMAGES}mice/`;
const miceWork1 = `${MICE_IMG_PATH}micework1.png`;
const miceWork2 = `${MICE_IMG_PATH}micework2.png`;
const miceWork3 = `${MICE_IMG_PATH}micework3.png`;

export const validName = (value) => !(value && /^(?!\s)([a-zA-Z ]+)$/i.test(value) ? undefined : (value ? 'invalid name' : undefined));

export const NavigationLinks = [{
	text: 'OFFERINGS',
	type: 'off',
	link: 'Offerings',
	trackVal: '',
	pageurl: PATHS.MICE_PAGE
},
{
	text: 'HOW IT WORKS?',
	type: 'works',
	link: 'Works',
	trackVal: '',
	pageurl: PATHS.MICE_PAGE
}];

export const bannerCarouselData = {
	mainHeading: 'Group Bookings Simplified',
	sliderData: [{
		heading: '<span class="highlight-heading">M</span>.I.C.E',
		subHeading: 'Looking for the perfect business <span class="highlight-heading">meeting</span> venue?',
		carouselUrl: {
		}
	},
	{
		heading: 'M.<span class="highlight-heading">I</span>.C.E',
		subHeading: 'Planning to <span class="highlight-heading">incentivise</span> your employees with their dream trip?',
		carouselUrl: {
		}
	},
	{
		heading: 'M.I.<span class="highlight-heading">C</span>.E',
		subHeading: 'Have an important <span class="highlight-heading">conference</span> coming up?',
		carouselUrl: {
		}
	},
	{
		heading: 'M.I.C.<span class="highlight-heading">E</span>.',
		subHeading: 'Need help with professional <span class="highlight-heading">event</span> execution?',
		carouselUrl: {
		}
	}
	]
};

export const whatweOfferData = {
	heading: 'What do We Offer ?',
	list: [
		{
			title: 'Meetings',
			subtext:
				'Every step of the planning and execution for a successful Meeting will be taken care by us. Our expertise lies in managing:',
			advantage: [
				'Day-long Meetings',
				'Channel Partners’ (Distributors, Dealers, Agents, and Vendors) Meets',
				'Seminars',
				'Corporate Board Meetings',
				'Sales Meet',
				'Meeting venues'
			]
		},
		{
			title: 'Incentives',
			subtext:
				'Our dedicated team manages end-to-end execution of specially curated package deals which are designed specifically to suit your objectives. We help you with organising:',
			advantage: [
				'Reward and Recognition Programmes',
				'Leadership Connects',
				'Tailored Group Tours with Team Engagement Activities & Entertainment Programmes',
				'Senior Management Off-sites'
			]
		},
		{
			title: 'Conferences',
			subtext:
				'Every step of the planning and execution for a successful conference will be taken care by us. Our expertise lies in managing:',
			advantage: [
				'Day Conferences with an Arrangement of High-tea, Lunch or Cocktail & Dinners',
				'Education Seminars',
				'Corporate Training Programmes'
			]
		},
		{
			title: 'Events',
			subtext:
				'Our vast network of venue providers and logistics enablement team ensures a hassle-free execution of an event, physical or virtual. Our services include:',
			advantage: [
				'Townhall Meetings',
				'Product Launches',
				'Annual Celebration Dinners',
				'Hospitality Services for Production Houses & Weddings',
				'Trade Fairs',
				'Virtual Meet',
				'Logistics for Concerts'
			]
		}
	]
};

export const HowItWorksData = {
	heading: 'How It Works ?',
	descp: 'Booking a MICE deal is now a seamless experience.',
	list: [
		{
			id: 1,
			img: miceWork1,
			alt: 'Step 1',
			title: 'Let Us Know Your Requirements',
			descp:
				'Fill the form and provide accurate details.'
		},
		{
			id: 2,
			img: miceWork2,
			title: 'Choose from Curated Packages',
			alt: 'Step 2',
			descp:
				'We filter the available options to offer you the best available deals & prices, in your defined budget and with the highest safety standards.'
		},
		{
			id: 3,
			img: miceWork3,
			title: 'Confirm Your Package & Confirm',
			alt: 'Step 3',
			descp:
				'You can block the services and confirm by paying the booking amount.'
		}
	]
};

export const successStoriesData = [
	{
		img: `${ASSET_PATH.IMAGES}mice/myBizBlogImg3.png`,
		date: 'June 21, 2021',
		title: 'HCL Training Meet',
		count: '1000 People, Orlando, USA'
	},
	{
		img: `${ASSET_PATH.IMAGES}mice/myBizBlogImg2.png`,
		date: 'May 21, 2021',
		title: 'Johndeere Annual Marketing Conference ',
		count: '1000 People, Orlando, USA'
	},
	{
		img: `${ASSET_PATH.IMAGES}mice/myBizBlogImg1.png`,
		date: 'May 21, 2021',
		title: 'HCL Training Meet',
		count: '1000 People, Orlando, USA'
	},
	{
		img: `${ASSET_PATH.IMAGES}mice/myBizBlogImg4.png`,
		date: 'April 21, 2021',
		title:
			'React Meet up',
		count: '1000 People, Orlando, USA'
	}
];

export const chooseMmtBusinessData = {
	heading: 'Why Choose MakeMyTrip for Business ?',
	descp: 'Being a one-stop platform to manage all your business travel requirements, our vast capabilities will ensure you will have a smooth experience.',
	subTitle: 'Our Unmatched Travel Portfolio',
	businessList: [
		{
			width: '276px',
			decp: 'Wide Inventory for Flights and Hotels'
		},
		{
			width: '158px',
			decp: 'Real-Time Availability'
		},
		{
			width: '290px',
			decp: 'MakeMyTrip’s Proprietary Technology'
		},
		{
			width: '154px',
			decp: 'Best-price Guarantee'
		},
		{
			width: '154px',
			decp: 'GST Assurance'
		},
		{
			width: '154px',
			decp: 'Customer Service'
		}
	]
};

export const portfolioData = [
	{
		name: 'Domestic Tickets',
		url: ''
	},
	{
		name: 'Domestic Packages',
		url: ''
	},
	{
		name: 'Domestic Hotels',
		url: ''
	},
	{
		name: 'Fixed Departures India',
		url: ''
	},
	{
		name: 'Customised Holidays',
		url: ''
	},
	{
		name: 'Buses',
		url: ''
	},
	{
		name: 'Activities and Experiences',
		url: ''
	},
	{
		name: 'Airport & Outstation Cabs',
		url: ''
	},
	{
		name: 'International Tickets ',
		url: ''
	},
	{
		name: 'Cruise Holidays ',
		url: ''
	},
	{
		name: 'International Packages ',
		url: ''
	},
	{
		name: 'Fixed Departures overseas ',
		url: ''
	},
	{
		name: 'Gift Cards',
		url: ''
	},
	{
		name: 'Charter Flights',
		url: ''
	},
	{
		name: 'Group Ticketing',
		url: ''
	}
];

export const partnerLogosData1 = [
	{
		logo: 'logoAltBalaji'
	},
	{
		logo: 'logoAxis'
	},
	{
		logo: 'logoAirtel'
	},
	{
		logo: 'logoBibaNew'
	},
	{
		logo: 'logoBlackberryGrey'
	},
	{
		logo: 'logoBML'
	},
	{
		logo: 'logoCarrier'
	},
	{
		logo: 'logoCitiBank'
	},
	{
		logo: 'logoDunzo'
	},

	{
		logo: 'logoEY'
	},

	{
		logo: 'logoSbiCard'
	}
];

export const partnerLogosData2 = [

	{
		logo: 'logoEmmay'
	},

	{
		logo: 'logoGoogle'
	},
	{
		logo: 'logoHcl'
	},
	{
		logo: 'logoHoneywell'
	},
	{
		logo: 'logoJagsonPal'
	},
	{
		logo: 'logoJKLakshmi'
	},
	{
		logo: 'logoJohnDeere'
	},
	{
		logo: 'logoKenStar'
	},
	{
		logo: 'logoPathLabNew'
	},
	{
		logo: 'logoLG'
	}
];

export const partnerLogosData3 = [
	{
		logo: 'logoMamaearth'
	},
	{
		logo: 'logoMaxInsurance'
	},
	{
		logo: 'logoMiXiomi'
	},
	{
		logo: 'logoNissin'
	},
	{
		logo: 'logoPaytm'
	},
	{
		logo: 'logoPepsico'
	},
	{
		logo: 'logoRaychem'
	},
	{
		logo: 'logoRedington'
	},
	{
		logo: 'logoSunHeart'
	},
	{
		logo: 'logoTencent'
	}
];

export const testimonialData = [
	{
		desp: `With support from MMT team we could make the event as one of the best in industry. 
			 Right from Airport to Back you have given seamless experience to our guest. 
			Would like to thank entire MMT team and shall surely look forward for greater association in time to come. `,
		userName: 'Sunil Jain ',
		userCompany: 'CEO',
		logo: 'logoKenStar'
	},
	{
		desp: `We have been associated with MMT team since Aug’19 and have been able to successfully execute our Top 4 
					flagship meets spread across destinations , Champions Meet in Phuket, Thailand, CEO’s Council in New Zealand, 
					Leadership Meet in Delhi , Executive Council in Phuket, Thailand `,
		userName: 'Soumendu',
		userCompany: 'Vice President – Strategy & Sales Promotion',
		logo: 'logoMaxInsurance'
	},
	{
		desp: `I think team MMT has done a fantastic job in organising such a massive event for us which we were fearing to 
						be a complete logistical nightmare . Getting 750 dealers from 4 states to one destination is no easy feat. 
						 As I understand it, I believe there were around 35 hubs where coaches were moved from. Wow! That’s a hell of a lot.  `,
		userName: 'Nitish Chopra',
		userCompany: 'Head - Branding & Communication',
		logo: 'logoJKLakshmi'
	},
	{
		desp: `We would like to extend our deep gratitude to the MMT Team for a very well organized Offsite.
					The care shown from booking, venue level coordination to the check-out and drop process was appreciated by 
					all the attendees. Look forward to having your team as our partner for future events. `,
		userName: 'Anand Panda',
		userCompany: '',
		logo: 'logoCitiBank'
	},
	{
		desp: `I would like to take the opportunity to thank you for being an excellent partner to Dunzo for our offsite 
					for 140 employees. The folks thoroughly enjoyed the trip and everyone was amazed by the amount of planning 
					and the outstanding arrangements that were made during the stay and transits at every leg of the trip.`,
		userName: 'Ruchika Pillai',
		userCompany: 'Lead, Communication',
		logo: 'logoDunzo'
	},
	{
		desp: `When we were looking for travel partner to resume our events post a forced break due to COVID, 
					we were glad to find a reliable and trusted partner in MakeMyTrip. With your support, we have been able 
					to execute 11 events in a span of a month and the execution has been flawless. The choice of hotels, 
					venues, smooth airline booking experience, sharp commercials and hands on operations has ensured that 
					delegates had a wonderful experience. `,
		userName: 'Varun Bansal ',
		userCompany: '',
		logo: 'logoJagsonPal',
		marginB: '0'
	}
];

export const queryFormFields = [
	{
		name: 'name',
		label: 'Your Name',
		placeHolder: 'Enter your Name',
		value: '',
		nocHangeError: true,
		errorOnBlur: true,
		validation: {
			required: {
				msg: 'Required!'
			},
			custom: {
				validator: validName,
				msg: 'Not a valid Name'
			}
		},
		formatSave: formatName,
		type: 'text',
		isMandatory: true,
		outLabel: true,
		mmtTheme: true
	},
	{
		value: '',
		name: 'emailId',
		label: 'Work Email Id',
		placeHolder: 'Enter your Email Id',
		type: 'email',
		validation: {
			required: {
				msg: 'Required!'
			},
			custom: {
				validator: validEmail,
				msg: 'Enter Valid Email'
			}
		},
		errorOnBlur: true,
		nocHangeError: true,
		isMandatory: true,
		outLabel: true,
		customClass: 'half',
		mmtTheme: true
	},
	{
		name: 'phoneNo',
		label: 'Mobile No.',
		placeHolder: 'Enter 10 digit Mobile No',
		value: '',
		maxLen: '10',
		validation: {
			required: {
				msg: 'Required!'
			},
			custom: {
				validator: validPhone,
				msg: 'Invalid phone number, must be 10 digits'
			}
		},
		type: 'tel',
		isMandatory: true,
		outLabel: true,
		errorOnBlur: true,
		customClass: 'half',
		mmtTheme: true
	},
	{
		name: 'travelMonth',
		label: 'Month of Travel',
		value: '',
		validation: {
			required: {
				msg: 'Required!'
			}
		},
		options: getTravelMonths(),
		isOpenTop: true,
		type: 'select',
		isMandatory: true,
		outLabel: true,
		errorOnBlur: true,
		customClass: 'oneThird',
		mmtTheme: true
	},
	{
		name: 'destinationType',
		label: 'Destination Type',
		value: '',
		errorOnBlur: true,
		validation: {
			required: {
				msg: 'Required!'
			}
		},
		options: [{
			value: 'Domestic',
			label: {
				labelHead: 'Domestic'
			}
		},
		{
			value: 'International',
			label: {
				labelHead: 'International'
			}
		}
		],
		isOpenTop: true,
		type: 'select',
		isMandatory: true,
		outLabel: true,
		errorOnBlur: true,
		customStyle: 'mice',
		customClass: 'oneThird',
		mmtTheme: true
	},
	{
		name: 'noOfGuests',
		label: 'No of Guests',
		errorOnBlur: true,
		value: '',
		validation: {
			required: {
				msg: 'Required!'
			}
		},
		placeHolder: 'Enter No of Guests',
		isOpenTop: true,
		type: 'number',
		isMandatory: true,
		outLabel: true,
		errorOnBlur: true,
		customClass: 'oneThird',
		mmtTheme: true
	}
];

const months = getTravelMonths({ mobileLabel: MICE_CONSTANTS.SHORT_MONTH_FORMAT, desktopLabel: MICE_CONSTANTS.MONTH_FORMAT }, MICE_CONSTANTS.MONTH_FORMAT);
export const travelMonthsOptions = formatTravelMonth(months);

export const guestOptions = [
	{
		value: '10 - 50',
		label: '10 - 50',
		apiDataKey: {
			min: 10,
			max: 50
		}
	},
	{
		value: '50 - 100',
		label: '50 - 100',
		apiDataKey: {
			min: 50,
			max: 100
		}
	},
	{
		value: 'More than 100',
		label: 'More than 100',
		apiDataKey: {
			min: 100,
			max: 1000
		}
	}
];
export const getQuotesFields = [
	{
		name: 'subHeading',
		type: 'readOnly',
		content: 'Just fill out the form, and our team of MICE booking experts will get back to you shortly with suitable options.'
	},
	{
		name: 'name',
		label: 'Your Name',
		placeHolder: 'Enter your Name',
		value: '',
		nocHangeError: true,
		errorOnBlur: true,
		validation: {
			required: {
				msg: 'Required!'
			},
			custom: {
				validator: validName,
				msg: 'Not a valid Name'
			}
		},
		formatSave: formatName,
		type: 'text',
		isMandatory: true,
		outLabel: true,
		mmtTheme: true
	},
	{
		value: '',
		name: 'emailId',
		label: 'Work Email Id',
		placeHolder: 'Enter your Email Id',
		type: 'email',
		validation: {
			required: {
				msg: 'Required!'
			},
			custom: {
				validator: validEmail,
				msg: 'Enter Valid Email'
			}
		},
		errorOnBlur: true,
		nocHangeError: true,
		isMandatory: true,
		outLabel: true,
		customClass: 'half',
		mmtTheme: true
	},
	{
		name: 'phoneNo',
		label: 'Mobile No.',
		placeHolder: 'Enter 10 digit Mobile No',
		value: '',
		maxLen: '10',
		validation: {
			required: {
				msg: 'Required!'
			},
			custom: {
				validator: validPhone,
				msg: 'Invalid phone number, must be 10 digits'
			}
		},
		type: 'tel',
		isMandatory: true,
		outLabel: true,
		errorOnBlur: true,
		customClass: 'half',
		mmtTheme: true
	},
	{
		isMulti: false,
		label: 'Month of Travel',
		outLabel: true,
		isMandatory: true,
		name: 'travelMonth',
		key: 'travelMonth',
		type: 'select',
		validation: {
			required: {
				msg: 'Required!'
			}
		},
		isSearchable: false,
		customClass: 'half',
		trackVal: '',
		theme: isDeviceMobile() ? 'cmn' : 'mmt',
		options: travelMonthsOptions
	},
	{
		isMulti: false,
		label: 'No. of Guests',
		outLabel: true,
		isMandatory: true,
		name: 'guestCount',
		key: 'guestCount',
		type: 'select',
		isSearchable: false,
		validation: {
			required: {
				msg: 'Required!'
			}
		},
		customClass: 'half',
		trackVal: '',
		theme: isDeviceMobile() ? 'cmn' : 'mmt',
		options: guestOptions

	},
	{
		name: 'services',
		value: '',
		placeHolder: '',
		type: 'checkbox',
		bottom_M: '12',
		customClass: isDeviceMobile() ? 'miceStyle' : 'miceForm',
		error: '',
		options: [
			{
				label: 'Flights',
				value: true

			},
			{
				label: 'Transfers',
				value: true

			},
			{
				label: 'Accomodation',
				value: true

			}
		]
	}

];

export const CommentField = {
	name: 'comments',
	label: 'Any Notes for Us ?',
	placeHolder: 'Write it here',
	value: '',
	nocHangeError: true,
	errorOnBlur: true,
	type: 'textArea',
	isMandatory: false,
	mmtTheme: true,
	outLabel: true
};

export const MICE_MODAL_HEADING = 'Reach out to us for';

export const MiceQueryModalData = {
	mobileTitle: MICE_MODAL_HEADING,
	customClass: 'queryform'
};

export const SUBMISSION_MODAL = 'SUB_MODAL';

export const MODAL_TYPE = {
	SUBMISSION_MODAL: 'SUB_MODAL',
	QUERY_FORM: 'QUERY_FORM',
	T_AND_C: 'T_AND_C'
};

export const MICE_SERVICES = 'Services Required:';

export const successPopupContent = `<p className="appendBottom24">Our representative will contact you 
within 24 hours to confirm the appointment.</p > <p className="appendBottom32">Please be available on the given mobile no.</p>`;

export const destinationTypeOptions = [
	{
		value: 'DOMESTIC',
		label: 'Domestic',
		infoText: 'Inside India',
		mobileLabel: 'Domestic',
		subLabel: 'Inside India',
		apiDataKey: 'Domestic',
		urlDataKey: 'dom'
	},
	{
		value: 'INTERNATIONAL',
		label: 'International',
		infoText: 'Outside India',
		mobileLabel: 'International',
		subLabel: 'Outside India',
		apiDataKey: 'International',
		urlDataKey: 'int'
	}
];

export const eventTypeOptions = [
	{
		value: 'TEAM_OFFSITE',
		label: 'Team Offsite',
		apiDataKey: 'TEAM_OFFSITE',
		urlDataKey: 'team-offsite'
	},
	{
		value: 'ANNUAL_MEETING',
		label: 'Annual Meeting',
		apiDataKey: 'ANNUAL_MEETING',
		urlDataKey: 'annual-meeting'
	},
	{
		value: 'TOWNHALL',
		label: 'Townhall',
		apiDataKey: 'TOWNHALL',
		urlDataKey: 'townhall'
	},
	{
		value: 'BOARD_MEETINGS',
		label: 'Board Meeting',
		apiDataKey: 'BOARD_MEETINGS',
		urlDataKey: 'board-meetings'
	},
	{
		value: 'CONFERENCES',
		label: 'Conferences',
		apiDataKey: 'CONFERENCES',
		urlDataKey: 'conferences'
	},
	{
		value: 'PRODUCT_LAUNCH',
		label: 'Product Launch',
		apiDataKey: 'PRODUCT_LAUNCH',
		urlDataKey: 'product-launch'
	}
];

export const destinationSearchFilters = [
	{
		isMulti: false,
		label: 'Destination Type',
		outLabel: true,
		isMandatory: false,
		theme: 'cmn',
		customClass: 'mice_dest',
		name: 'destinationType',
		key: 'destinationType',
		type: 'select',
		trackVal: '',
		options: destinationTypeOptions
	},
	{
		isMulti: false,
		label: 'Event Type',
		outLabel: true,
		isMandatory: false,
		name: 'eventType',
		key: 'eventType',
		type: 'select',
		trackVal: '',
		options: eventTypeOptions
	}
];

export const defaultOptionSelected = {
	destinationType: destinationTypeOptions[0],
	eventType: eventTypeOptions[0],
	city: defaultCity
};

export const defaultRequestObj = {
	filter: {
		destinationType: defaultOptionSelected.destinationType.value,
		eventType: defaultOptionSelected.eventType.value
	}
};

export const dropQueryObj = {
	isDropQuery: true,
	imgText: 'Looking for more options?',
	heading: 'Tell us your requirements, our booking expert will reach out to you with matching venue options'
};

export const SideBannerUrl = 'https://promos.makemytrip.com/images/myBiz/miceimage.png';

export const T_AND_C_CONFIG = {
	[APPLICATION_CONSTANTS.POPUP]: {
		heading: {
			fsize: '22px',
			bottom_M: '10',
			f_weight: '300',
			color: '#000',
			top_M: '30',
			left_P: '30',
			right_P: '30'
		},
		wrapper: {
			left_P: '45',
			right_P: '30'
		},
		listing: {
			bottom_M: '12'
		}
	},
	[APPLICATION_CONSTANTS.OTHERS]: {
		heading: {
			bottom_M: '10',
			f_weight: '700',
			color: '#000'
		},
		wrapper: {
			left_P: '16',
			right_P: '16'
		},
		listing: {
			bottom_M: '4'
		}
	}
};

export const T_AND_C_TEXT = 'Terms & Conditions';
